// extracted by mini-css-extract-plugin
export var aggregationCell = "_2l-p";
export var aggregationRow = "_2l-o";
export var borderlessSpinnerContainer = "_2l-3";
export var cardLayout = "_2l-6";
export var cardLayoutNoFooter = "_2l-a";
export var cardLayoutPageControl = "_2l-9";
export var cardLayoutWithFooter = "_2l-8";
export var closeIcon = "_2l-h";
export var columnHeaderSurface = "_2l-d";
export var columnHeaderSurfaceDragOverlay = "_2l-x";
export var columnHeaderSurfaceResizing = "_2l-u";
export var contextMenuAnchor = "_2l-1";
export var draggableColumnHeader = "_2l-v";
export var draggableColumnHeaderOverlay = "_2l-w";
export var expandIcon = "_2l-i";
export var expanded = "_2l-j";
export var filterDropdown = "_2l-k";
export var filterDropdownDivider = "_2l-f";
export var filterDropdownHeader = "_2l-n";
export var filterDropdownItem = "_2l-m";
export var filterDropdownModal = "_2l-l _2l-k";
export var filterItem = "_2l-e";
export var normalCellWithAdjustableBorder = "_2l-g";
export var pinButtonContainer = "_2l-q";
export var pinIcon = "_2l-r";
export var pinIconActive = "_2l-s";
export var spinner = "_2l-0";
export var spinnerContainer = "_2l-2";
export var tableContainer = "_2l-4";
export var tableContentDraggingColumns = "_2l-c";
export var tableContentInner = "_2l-7";
export var tableContentInnerFill = "_2l-b";
export var tableContentWrapper = "_2l-5";
export var viewButtonContainer = "_2l-t";